module.exports = __webpack_public_path__ + "img/ms-3.ab7c3649.webp";